import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.array.push.js";
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
const confetti = require("@assets/js/confetti.js");
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "giftDetail",
  computed: {
    ...taskVuex.mapState(["timerObjs"]),
    fmt_pre() {
      return formatter.fmt_pre;
    },
    confetti() {
      return confetti;
    }
  },
  data() {
    return {
      tabList: [],
      stepStars: [],
      popGetTelegramShow: true,
      isDemo: false,
      step: 0,
      isPageLoading: false,
      isRefresh: false,
      luckyInfo: null,
      prizeList: null,
      fullPrizeList: null,
      drawResult: null,
      drawOption: {
        baseItemWidth: 0,
        itemGap: null,
        selectorOffset: null,
        minCycles: 2,
        itemsContainer: null,
        itemsWidth: null,
        itemContrainer: null,
        itemWidth: 0,
        totalItems: 0,
        selectorOffset: null,
        selectorRef: null,
        startOffset: null,
        itemsScrollContainer: null,
        repeats: null
      },
      isDrawOpening: false,
      prizeListScroll: null,
      rowGiftItem: {
        order_id: 0,
        gift_type: 1,
        order_status: null
      }
    };
  },
  methods: {
    ...userVuex.mapMutations(["setUserData"]),
    onTry() {
      this.step = 0;
    },
    onDemoSwitch() {
      this.isDemo = !this.isDemo;
    },
    onDrawScroll(e) {
      const target = e.target;
      const scrollLeft = target.scrollLeft;
      // this.$nextTick(() => {
      //   if (this.drawOption.itemsContainer) {
      //     this.drawOption.itemsContainer.style.transform = `translateX(-${scrollLeft}px)`;
      //   }
      // })
    },

    async onOpen() {
      if (this.isDrawOpening) return;
      this.isDrawOpening = true;
      const res = await this.getLuckyResult();
      if (!res) {
        this.isDrawOpening = false;
        return;
      }
      if (this.$refs.nGiftHeadRef && !this.isDemo) {
        this.$refs.nGiftHeadRef.starInfo.balance = this.$refs.nGiftHeadRef.starInfo.balance < this.luckyInfo.price_extras.stars.price_stars ? this.$refs.nGiftHeadRef.starInfo.balance : this.$refs.nGiftHeadRef.starInfo.balance - this.luckyInfo.price_extras.stars.price_stars;
      }
      this.rowGiftItem.order_id = 0;
      this.rowGiftItem.gift_type = 1;
      this.rowGiftItem.order_status = null;
      await this.startDrawRolling();
      await new Promise(resolve => setTimeout(resolve, 500));
      this.step = 1;
      await new Promise(resolve => setTimeout(resolve, 500));
      this.isDrawOpening = false;
      if (!this.isDemo) {
        this.setConfetti();
      }
      if (this.drawResult) {
        this.setUserData(this.drawResult.user);
        this.$refs.nGiftHeadRef && this.$refs.nGiftHeadRef.refreshFnc();
      }
    },
    setConfetti() {
      this.confetti({
        particleCount: 20,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        }
      });
      this.confetti({
        particleCount: 20,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        }
      });
    },
    async initFnc(item) {
      this.isPageLoading = true;
      const config = await this.setActivityConfig(item);
      if (!config) {
        this.isRefresh = false;
        return;
      }
      const items = await this.setLuckyList();
      if (!items) {
        this.isRefresh = false;
        return;
      }
      this.isPageLoading = false;
      this.drawInitItem();
      console.log("itemsitemsitemsitemsitems", items);
    },
    async onTab(item) {
      if (this.isDrawOpening && item.id == this.luckyInfo.id) return;
      this.step = 0;
      this.luckyInfo = item;
      await this.initFnc(item);
    },
    setActivityConfig(item) {
      return new Promise(async resolve => {
        if (item) {
          this.luckyInfo = item;
          resolve(this.luckyInfo);
          return;
        }
        const res = await _v.$http.post("/lucky/lottery/list", {
          provider: "official",
          type: 3
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (data.length <= 0) {
            this.luckyInfo = {};
          } else {
            this.tabList = data;
            this.luckyInfo = data[0];
          }
          resolve(this.luckyInfo);
        }, () => {
          resolve();
        });
      });
    },
    setLuckyList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/items", {
          lotteryId: this.luckyInfo.id
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (data.length <= 0) {
            resolve();
            return;
          }
          const empty = {
            id: null,
            gift_extra: {
              gift_thumb: "",
              gift_stars: 0
            },
            title: ""
          };
          this.prizeListScroll = [];
          this.prizeListScroll = JSON.parse(JSON.stringify(data));
          this.prizeListScroll.unshift(empty);
          this.prizeListScroll.unshift(empty);
          this.prizeListScroll.push(empty);
          this.prizeListScroll.push(empty);
          this.prizeList = data;
          console.log("this.prizeListthis.prizeList", this.prizeList);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    getLuckyResult() {
      return new Promise(async resolve => {
        const fnc = async () => {
          const res = await _v.$http.post("/lucky/lottery/draw", {
            lotteryId: this.luckyInfo.id,
            count: this.selectCountOptions,
            priceType: "stars",
            isDemo: Number(this.isDemo)
          });
          if (res.code == 0) {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            if (!data) {
              this.$toasted.clear();
              this.$toasted.error(res.message);
              resolve();
              return;
            }
            if (data?.chainInfo) {
              console.log("data.chainInfo.payment_url", data.chainInfo.payment_url);
              const payRef = await this.openInvoiceStarPay({
                url: data.chainInfo.payment_url
              });
              if (!payRef) {
                resolve();
                return;
              }
              const checkRef = await this.popCheckStars(data?.chainInfo);
              if (!checkRef) {
                resolve();
                return;
              }
              await fnc();
              return;
            }
            this.drawResult = data;
            const winning_item = this.drawResult.winning_item;
            this.rowGiftItem.gift_type = this.drawResult.winning_item.gift_extra[0].gift_type;
            const winningIndex = this.prizeList.findIndex(item => {
              return winning_item.id == item.id && winning_item.gift_extra[0].id == item.gift_extra.id;
            });
            this.drawResult = {
              ...data,
              winningIndex
            };
            console.log("this.drawResult", this.drawResult);
            resolve(data);
          } else {
            this.$toasted.clear();
            this.$toasted.error(res.message);
            if (res.code === 404) {
              this.initFnc();
              resolve();
              return;
            } else {
              resolve();
              return;
            }
          }
        };
        fnc();
      });
    },
    //星星支付
    openInvoiceStarPay: async params => {
      return new Promise(async resolve => {
        try {
          const res = await _v.WebApp.openInvoice(params.url);
          async function invoiceClosedFnc(e) {
            _v.WebApp.offEvent("invoiceClosed", invoiceClosedFnc);
            console.log("ressssssss", res, e?.status);
            if (e?.status && e.status == "paid") {
              resolve(1);
            } else if (e?.status && e.status === "cancelled") {
              resolve();
            }
          }
          _v.WebApp.onEvent("invoiceClosed", invoiceClosedFnc);
        } catch (err) {
          console.log("err====", err);
        }
      });
    },
    async popCheckStars(resp, time = 1) {
      return new Promise(async resolve => {
        const fnc = async resp => {
          this.timerObjs.giftPage.giftStarTimer = setTimeout(async () => {
            let params = {
              orderId: resp.deposit_id,
              action: "deposit"
            };
            const res = await _v.$http.post("/user/assets/order/check", params);
            if (!res) {
              this.$toasted.error("Upgrade failed, please try again");
              resolve();
            } else if (res.data.status == 1) {
              clearTimeout(this.timerObjs.giftPage.giftStarTimer);
              await fnc(resp);
            } else if (res.data.status == 2) {
              clearTimeout(this.timerObjs.giftPage.giftStarTimer);
              resolve(res);
            } else {
              clearTimeout(this.timerObjs.giftPage.giftStarTimer);
              this.$toasted.error(res.message);
              resolve();
            }
          }, time * 1000);
        };
        await fnc(resp);
      });
    },
    drawInitItem() {
      this.$nextTick(() => {
        this.drawOption.itemsContainer = this.$refs.itemsContainer;
        if (!this.drawOption.itemsContainer) {
          return;
        }
        this.drawOption.itemsWidth = window.innerWidth;
        this.$refs.selectorRef.style.left = this.drawOption.itemsWidth / 2 - this.$refs.selectorRef.offsetWidth / 2 + "px";
        this.drawOption.itemContrainer = this.drawOption.itemsContainer.children[0];
        const item0Contrainer = this.drawOption.itemsContainer.children[0];
        const item1Contrainer = this.drawOption.itemsContainer.children[1];
        this.drawOption.itemGap = item1Contrainer.offsetLeft - (item0Contrainer.offsetLeft + item0Contrainer.offsetWidth);
        this.drawOption.baseItemWidth = this.drawOption.itemContrainer.offsetWidth;
        this.drawOption.itemWidth = this.drawOption.baseItemWidth + this.drawOption.itemGap;
        this.drawOption.selectorOffset = (this.drawOption.itemsWidth - this.drawOption.baseItemWidth) / 2;
        const prizeList = this.prizeList;
        if (!prizeList) return;
        const minItems = this.drawOption.minCycles * prizeList.length;
        const repeats = Math.ceil(minItems / prizeList.length) + 1;
        this.drawOption.repeats = repeats;
        console.log("minItems", minItems, repeats, this.prizeList.length);
        this.fullPrizeList = [];
        this.drawOption.itemsWidth = this.drawOption.itemsContainer.offsetWidth;
        for (let i = 0; i < repeats; i++) {
          this.fullPrizeList.push(...prizeList);
        }
        const extraCount = Math.ceil(this.drawOption.itemsWidth / this.drawOption.itemWidth);
        for (let i = 0; i < extraCount; i++) {
          this.fullPrizeList.push(prizeList[i % prizeList.length]);
        }
        this.drawOption.totalItems = this.fullPrizeList.length;
        const initialIndex = 2;
        const startOffset = initialIndex * this.drawOption.itemWidth - this.drawOption.selectorOffset;
        this.drawOption.itemsContainer.style.transform = `translateX(-${startOffset}px)`;
        this.drawOption.itemsScrollContainer = this.$refs.itemsScrollContainer;
        this.$refs.itemsScrollContainer.scrollLeft = `${startOffset + this.drawOption.itemWidth * 2}`;
        this.drawOption.startOffset = startOffset;
        for (let i = 0; i < repeats; i++) {
          this.fullPrizeList.push(...prizeList);
        }
      });
    },
    startDrawRolling() {
      return new Promise(resolve => {
        const drawResult = this.drawResult;
        const prizeCount = this.prizeList.length;

        // const randomIndex = Math.floor(Math.random() * prizeCount);
        const totalItems = this.drawOption.totalItems;
        let finalIndex = -1;
        for (let i = totalItems - prizeCount - 1; i < totalItems; i++) {
          if (this.fullPrizeList[i] === this.prizeList[drawResult.winningIndex]) {
            finalIndex = i;
            break;
          }
        }
        const container = this.drawOption.itemsContainer;
        const selectorCenter = this.drawOption.itemsWidth / 2;
        const targetEl = container.children[finalIndex];

        // item 在 container 内的 left 偏移  bn
        const itemLeftInContainer = targetEl.offsetLeft;
        const itemCenterInContainer = itemLeftInContainer + targetEl.offsetWidth / 2;

        // 所需滚动距离 = itemCenter - selectorCenter
        const targetOffset = itemCenterInContainer - selectorCenter;
        let position = 0;

        // 🚀 初始速度 & 减速参数
        let speed = 50;
        const minSpeed = 0.9;
        const deceleration = 0.95; // 越接近1越慢减速
        const that = this;
        function animate() {
          const distanceLeft = targetOffset - position;
          // console.log("distanceLeft", distanceLeft);

          // 动态调整速度：根据剩余距离逐步减速
          if (distanceLeft < 950) {
            speed *= deceleration;
            if (speed < minSpeed) speed = minSpeed;
          }
          position += speed;
          if (position >= targetOffset) {
            position = targetOffset;
            that.drawOption.itemsContainer.style.transform = `translateX(-${position}px)`;
            const scrollIndex = 2 + that.drawResult.winningIndex;
            const scrollLeft = scrollIndex * that.drawOption.itemWidth - (that.drawOption.itemsScrollContainer.offsetWidth - that.drawOption.baseItemWidth) / 2;
            that.drawOption.itemsScrollContainer.scrollLeft = scrollLeft - that.drawOption.itemGap * 2;
            resolve();
            return;
          }
          that.drawOption.itemsContainer.style.transform = `translateX(-${position}px)`;
          requestAnimationFrame(animate);
        }
        animate();
      });
    },
    onGetToTelegram(item) {
      this.$nextTick(() => {
        const _item = {
          ...item,
          recycling_stars: item.gift_extra[0].recycling_stars,
          id: item.log_id,
          gift_type: item.gift_extra[0].gift_type,
          order_status: this.rowGiftItem.order_status
        };
        console.log("_item_item_item_item_item,", item, _item);
        this.$refs.popSellGiftRef.popGetToTelegramShowFnc(true, _item);
      });
    },
    onSellPlatform(item) {
      this.$nextTick(() => {
        const _item = {
          ...item,
          recycling_stars: item.gift_extra[0].recycling_stars,
          id: item.log_id,
          gift_type: item.gift_extra[0].gift_type,
          order_status: this.rowGiftItem.order_status
        };
        console.log("_item_item_item_item_item,", item, _item);
        this.$refs.popSellGiftRef.popSellPlatformShowFnc(true, _item);
      });
    },
    popSellGiftFinish(type, item) {
      this.rowGiftItem.order_id = item.order_id;
      this.rowGiftItem.order_status = item.order_status;
      if (type == "sell") {} else if (type == "get") {}
    }
  },
  async mounted() {
    await this.initFnc();
  }
};